"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _phaser = _interopRequireDefault(require("phaser"));
var _sky = _interopRequireDefault(require("../../assets/sky.png"));
var _ground = _interopRequireDefault(require("../../assets/ground.png"));
var _martyHurt = _interopRequireDefault(require("../../assets/marty-hurt.png"));
var _cog = _interopRequireDefault(require("../../assets/cog.png"));
var _star = _interopRequireDefault(require("../../assets/star.png"));
var _starShine = _interopRequireDefault(require("../../assets/star-shine.png"));
var _restart = _interopRequireDefault(require("../../assets/restart.png"));
var _martyInPlane = _interopRequireDefault(require("../../assets/marty-in-plane.png"));
var _gameOver = _interopRequireDefault(require("../../assets/game-over.png"));
var _playbutton = _interopRequireDefault(require("../../assets/playbutton.svg"));
var _hit = _interopRequireDefault(require("../../assets/hit.m4a"));
var _reach = _interopRequireDefault(require("../../assets/reach.m4a"));
var _jump = _interopRequireDefault(require("../../assets/jump.m4a"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//@ts-ignore

//@ts-ignore

//@ts-ignore

class PreloadScene extends _phaser.default.Scene {
  constructor() {
    super("PreloadScene");
  }
  preload() {
    this.load.image("sky", _sky.default);
    this.load.image("ground", _ground.default);
    this.load.image("marty-in-plane", _martyInPlane.default);
    this.load.image("marty-hurt", _martyHurt.default);
    this.load.image("cog", _cog.default);
    this.load.image("star", _star.default);
    this.load.image("shiny-star", _starShine.default);
    this.load.image("restart", _restart.default);
    this.load.image("game-over", _gameOver.default);
    this.load.image("play", _playbutton.default);
    this.load.audio("jump", _jump.default);
    this.load.audio("hit", _hit.default);
    this.load.audio("progress", _reach.default);
  }
  create() {
    this.scene.start("PlayScene");
  }
}
var _default = exports.default = PreloadScene;